module.exports = __webpack_public_path__ + "static/media/img_construction_workers.775e43dc.png";